<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let className: string = '';
	export { className as class };
</script>

<div
	class={twMerge(
		'mx-auto h-7 w-7 animate-spin rounded-full border-4 border-solid border-slate border-t-transparent',
		className
	)}
/>
